import { useTranslator } from '@bluebeam/react-i18n';
import { Button } from '@bluebeam/react-skyline-button';
import { Dialog } from '@bluebeam/react-skyline-dialog';
import * as React from 'react';

export const refreshSessionModalLogoutButtonId =
  'refresh-session-modal-logout-btn';

const ExpiredTokenModal: React.FC = () => {
  const { translate } = useTranslator(['buttons', 'expiredTokenModal']);

  const hasExternalCredentials =
    window.location.pathname.startsWith('/labs/search/project/') &&
    window.location.hash.includes('accessToken=') &&
    window.location.hash.includes('idToken=');

  const handleLogoutClick = (): void => {
    window.location.assign('/');
  };

  const handleRefreshClick = (): void => {
    window.location.reload();
  };

  return (
    <Dialog
      ariaClose="Close"
      className="expiredTokenModal"
      size="small"
      title={translate('expiredTokenModal:header')}
    >
      <Dialog.Content>
        <p className="font-size-5 regular">
          {!hasExternalCredentials
            ? translate('expiredTokenModal:content')
            : translate('expiredTokenModal:closeTabContent')}
        </p>
      </Dialog.Content>
      <Dialog.Footer>
        {!hasExternalCredentials && (
          <>
            <Button
              size="32px"
              variant="text"
              id={refreshSessionModalLogoutButtonId}
              onClick={handleLogoutClick}
              style={{
                justifyContent: 'center',
                flex: 1,
              }}
            >
              {translate('buttons:signOut')}
            </Button>
            <Button
              size="32px"
              variant="filled"
              id="refresh-session-modal-refresh-btn"
              onClick={handleRefreshClick}
            >
              {translate('buttons:refreshSession')}
            </Button>{' '}
          </>
        )}
      </Dialog.Footer>
    </Dialog>
  );
};
export default ExpiredTokenModal;
